export default function AdminIcon({color}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      >
      <path
        style={{transition:'0.3s all'}}
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15 0.351562L3.0498 5.94082V15C4.33477 23.2236 8.31797 28.1063 15 29.6484C21.682 28.1063 25.6652 23.2236 26.9502 15V5.94082L15 0.351562ZM15 6.13359C17.1287 6.13359 18.8549 7.85977 18.8549 9.98848C18.8549 12.1172 17.1287 13.8434 15 13.8434C12.8713 13.8434 11.1451 12.1172 11.1451 9.98848C11.1451 7.85977 12.8713 6.13359 15 6.13359ZM22.3242 22.1314C19.4332 25.408 19.0477 25.9863 15 27.3357C11.1451 25.9863 10.7596 25.6008 7.67578 22.1314V19.626C9.21797 16.5422 11.5307 15.7711 15 15.3855C18.4693 15.7711 20.5893 16.5422 22.3242 19.626V22.1314Z"
        fill={color?color:"white"}
        
      />
    </svg>
  );
}
